const PUBLIC_DIRECTORY_THERAPY_DEFINITIONS = [
  { slug: 'traditional-finnish-sauna', name: 'Traditional Finnish Sauna' },
  { slug: 'sauna', name: 'Sauna' },
  { slug: 'infrared-sauna', name: 'Infrared Sauna' },
  { slug: 'ice-bath', name: 'Ice Bath' },
  { slug: 'cold-plunge', name: 'Cold Plunge' },
  { slug: 'contrast-therapy', name: 'Contrast Therapy' },
] as const;

export const PUBLIC_DIRECTORY_THERAPY_SLUGS = PUBLIC_DIRECTORY_THERAPY_DEFINITIONS.map((item) => item.slug);
export const PUBLIC_DIRECTORY_THERAPY_SET = new Set<string>(PUBLIC_DIRECTORY_THERAPY_SLUGS);

export function isPublicDirectoryTherapySlug(value: string | null | undefined) {
  if (!value) return false;
  return PUBLIC_DIRECTORY_THERAPY_SET.has(value.trim().toLowerCase());
}

export function getPublicDirectoryTherapyName(slug: string) {
  return PUBLIC_DIRECTORY_THERAPY_DEFINITIONS.find((item) => item.slug === slug)?.name ?? slug;
}

export function filterPublicDirectoryTherapies<T extends { slug: string }>(therapies: T[]): T[] {
  return therapies.filter((therapy) => isPublicDirectoryTherapySlug(therapy.slug));
}

export function getPublicVenueTherapySlug(
  therapies: Array<string | null | undefined>,
  primaryTherapy?: string | null,
) {
  const candidates = [primaryTherapy, ...therapies].filter((value): value is string => typeof value === 'string');
  const normalized = candidates
    .map((value) => value.trim().toLowerCase())
    .filter(Boolean);

  return normalized.find((value) => isPublicDirectoryTherapySlug(value)) ?? 'all';
}
